// src/components/PilahSampah/PilahSampahMenuScreen.js
import React from 'react';
import styles from './PilahSampah.module.css';
import { ACTIONS } from './PilahSampahGame'; // Impor Aksi

// Fungsi helper untuk fullscreen
const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch(() => alert("Mode layar penuh tidak didukung."));
    } else {
        document.exitFullscreen();
    }
};

function PilahSampahMenuScreen({ dispatch, onGoHome }) {
    return (
        <div className={`${styles.screen} ${styles.menuScreen} ${styles.active}`}>
            <div className={styles.gameLogo}>
                <div className={styles.trophyIcon}>🏆</div>
                <h1>Pilah Sampah Race</h1>
                <p>Guru Inspiratif</p>
            </div>
            <div className={styles.menuButtons}>
                <button 
                    className={`${styles.btn} ${styles.btnPrimary}`} 
                    onClick={() => dispatch({ type: ACTIONS.GO_TO_SCREEN, payload: 'level' })}
                >
                    🎮 Main
                </button>
                <button 
                    className={`${styles.btn} ${styles.btnSecondary}`}
                    onClick={toggleFullscreen}
                >
                    🖥️ Layar Penuh
                </button>
                {/* Tombol Papan Peringkat bisa ditambahkan kembali di sini jika sudah berfungsi */}
                <button 
                    className={`${styles.btn} ${styles.btnTertiary}`} 
                    onClick={onGoHome}
                >
                    ← Kembali ke Menu Utama
                </button>
            </div>
        </div>
    );
}

export default PilahSampahMenuScreen;